<template>
  <div class="promo-materials">
    <app-header-container>
      {{ $t('views.Dashboard.PromoMaterials.header') }}
    </app-header-container>

    <section class="promo-materials__section promo-materials__section--reverse b-typography">
      <div class="promo-materials__section-left">
        <h2 class="promo-materials__section-heading">{{ $t('views.Dashboard.PromoMaterials.downloadLayout') }}</h2>

        <div class="promo-materials__section-content">
          <div class="mt-1" v-html="downloadLayoutText"/>
          <div class="mt-3 d-flex direction-column" v-for="layout of downloadLayoutButtons" :key="layout.label" >
            <b v-if="layout.label">{{layout.label}}</b>
            <div class="d-flex wrap">
              <a class="mr-1 mt-1" v-for="button of layout.buttons" :key="button.label" :href="button.href">
                <v-button :color="button.color">{{button.label}}</v-button>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="promo-materials__section-right">
        <div class="promo-materials__images-grid">
          <img v-for="(imgSrc, index) of layoutImages" :src="imgSrc" :key="imgSrc" :alt="'download-layout-' + index"/>
        </div>
      </div>
    </section>

    <div class="divider reset-indent" v-if="isGoldStatus"></div>

    <section class="promo-materials__section promo-materials__section--single b-typography" v-if="isGoldStatus">
      <h2 class="heading-2 text--normalcase text--center">{{ $t('views.Dashboard.PromoMaterials.bannerWebsite.header') }}</h2>
      <p class="text--center mt-3"><b>{{$t('views.Dashboard.PromoMaterials.bannerWebsite.selectBSize')}}</b></p>
      <div class="mt-1 d-flex justify-center mb-3">
        <v-button :outline="activeTab!==728" color="primary" size="large" class="ma-05 banner__button" @click="activeTab = 728">728 x 90</v-button>
        <v-button :outline="activeTab!==300" color="primary" size="large" class="ma-05 banner__button" @click="activeTab = 300">300 x 600</v-button>
      </div>
      <div class="promo-materials__banner-list" v-show="activeTab === 728">
        <div class="d-flex wrap justify-center">
          <div class="d-flex wrap justify-center promo-materials__banner-horizontal " v-for="(banner, index) in banners['728']" :key="index">
            <div class="promo-materials__banner ma-1">
              <div class="promo-materials__banner-inner"><img alt="banner" :src="banner" /></div>
              <div class="promo-materials__banner-footer"><a @click.prevent="copyB(banner)" href="#"><span class="icon-code"></span><span class="ml-1">{{$t('views.Dashboard.PromoMaterials.bannerWebsite.copyHtml')}}</span></a></div>
            </div>
          </div>
        </div>
      </div>
      <div class="promo-materials__banner-list" v-show="activeTab === 300">
        <div class="d-flex wrap justify-center">
          <div class="promo-materials__banner-vertical " v-for="(banner, index) in banners['300']" :key="index">
            <div class="promo-materials__banner ma-1">
              <div class="promo-materials__banner-inner"><img alt="banner" :src="banner" /></div>
              <div class="promo-materials__banner-footer"><a @click.prevent="copyB(banner)" href="#"><span class="icon-code"></span><span class="ml-1">{{$t('views.Dashboard.PromoMaterials.bannerWebsite.copyHtml')}}</span></a></div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-center">
        <p class="mt-3 text--center banner__text">{{$t('views.Dashboard.PromoMaterials.bannerWebsite.description')}}</p>
      </div>
    </section>

    <div class="divider reset-indent" v-if="reqCountry.USA"></div>

    <section class="promo-materials__section promo-materials__section--single b-typography" v-if="reqCountry.USA">
      <div>
        <h2 class="heading-2 mb-3">{{ $t('views.Dashboard.PromoMaterials.referralLink.header') }}</h2>
        <div class="promo-materials__banner">
          <div class="promo-materials__banner-inner">
            <a :href="staticBaseUrl + '/legal/merchant/promotional_material/business-offer.pdf'" target="_blank"><img alt="banner" :src="businessOffer"/></a>
          </div>
          <div class="promo-materials__banner-footer">
            <a :href="staticBaseUrl + '/legal/merchant/promotional_material/business-offer.pdf'" target="_blank"><span>{{$t('views.Dashboard.PromoMaterials.download')}}</span></a>
          </div>
        </div>
      </div>
    </section>

    <div class="divider reset-indent" v-if="isGoldStatus"></div>

<!--    <section class="promo-materials__section b-typography pb-2" v-if="isGoldStatus">-->
<!--      <div class="promo-materials__section-left">-->
<!--        <h2 class="heading-2 text&#45;&#45;normalcase">{{ $t('views.Dashboard.PromoMaterials.referralLink.header1') }}</h2>-->
<!--        <p class="mt-2" v-html="$t('views.Dashboard.PromoMaterials.referralLink.text')"/>-->
<!--      </div>-->
<!--      <div class="promo-materials__section-right d-flex direction-column align-center">-->
<!--        <qr-code style="cursor:pointer;" @click.native="copyRefLink()" :content="referralLink"/>-->
<!--        <p>{{ $t('views.Dashboard.PromoMaterials.referralLink.header1') }}: <a class="cursor-pointer ref_link_copy text&#45;&#45;center" href="javascript:void(0)" v-if="isGoldStatus && goldShopLogin" @click="copyRefLink()">-->
<!--          <b style="display: inline-flex; align-items: center;">-->
<!--            <span style="display: block">{{goldShopLogin}}</span>-->
<!--            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width: 18px; height: 18px; margin-left: 5px">-->
<!--              <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75" />-->
<!--            </svg>-->
<!--          </b>-->
<!--        </a></p>-->
<!--        <div class="mt-3" v-if="!isNative">-->
<!--          <v-button v-if="isGoldStatus && goldShopLogin" no-border="no-border" color="primary" :disabled="loading" :loading="loading" @click="download_qr">{{ $t('views.Dashboard.PromoMaterials.referralLink.downloadQrCode') }}</v-button>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->

    <section class="promo-materials__section promo-materials__section--single b-typography">
      <div class="promo-materials__section-left">
        <h2 class="heading-2 text--normalcase">{{ $t('views.Dashboard.PromoMaterials.referralLink.header1') }}</h2>
      </div>
      <qr-code style="cursor:pointer;" @click.native="copyRefLink()" :content="referralLink"/>
<!--      <p>{{ $t('views.Dashboard.PromoMaterials.goldshopLogin') }}: <a class="cursor-pointer ref_link_copy text&#45;&#45;center" href="javascript:void(0)" v-if="isGoldStatus && goldShopLogin" @click="copyRefLink()">-->
<!--        <b>{{goldShopLogin}}</b>-->
<!--      </a></p>-->
      <p>{{ $t('views.Dashboard.PromoMaterials.referralLink.header1') }}: <a class="cursor-pointer ref_link_copy text--center" href="javascript:void(0)" v-if="isGoldStatus && goldShopLogin" @click="copyRefLink()">
        <b style="display: inline-flex; align-items: center;">
          <span style="display: block">{{goldShopLogin}}</span>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width: 18px; height: 18px; margin-left: 5px">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75" />
          </svg>
        </b>
      </a></p>
      <div class="mt-3 d-flex justify-center" v-if="!isNative">
        <v-button v-if="isGoldStatus && goldShopLogin" no-border="no-border" color="primary" :disabled="loading" :loading="loading" @click="download_qr">{{ $t('views.Dashboard.PromoMaterials.referralLink.downloadQrCode') }}</v-button>
      </div>
      <div v-html="$t('views.Dashboard.PromoMaterials.goldshopURLText')">
      </div>
    </section>
  </div>
</template>

<script>
import qr from 'qrcode-generator'
import { Capacitor } from '@capacitor/core'

import AppHeaderContainer from '@/ui/layout/AppHeaderContainer'
import vButton from '@/ui/controls/vButton'
import QrCode from '@/ui/elements/QrCode'

import reqCountry from '@/mixins/reqCountry'
import profile from '@/mixins/profile'
import isGoldStatus from '@/mixins/isGoldStatus'
import copyToClipboard from '@/mixins/copyToClipboard'
import staticBaseUrl from '@/mixins/staticBaseUrl'
import forwardMoreOnMobile from '@/mixins/forwardMoreOnMobile'

import promotion1 from '@/assets/images/promo_material/1.jpg'
import promotion2 from '@/assets/images/promo_material/2.jpg'
import promotion3 from '@/assets/images/promo_material/3.jpg'
import promotion4 from '@/assets/images/promo_material/4.jpg'

import promotionUS1 from '@/assets/images/promo_material/1-us.jpg'
import promotionUS2 from '@/assets/images/promo_material/2-us.jpg'
import promotionUS3 from '@/assets/images/promo_material/3-us.jpg'

import businessOffer from '@/assets/images/promo_material/business-offer.jpg'

export default {
  components: {
    AppHeaderContainer,
    // Box,
    vButton,
    QrCode
  },

  mixins: [reqCountry, isGoldStatus, copyToClipboard, staticBaseUrl, profile, forwardMoreOnMobile],

  data () {
    return {
      businessOffer,
      activeTab: 728,
      loading: false,
      isNative: Capacitor.isNativePlatform(),
      shortenedUrl: null
    }
  },

  computed: {
    goldShopLogin () {
      return this.profile?.goldShopLogin ?? null
    },

    referralLink () {
      // let login = this.goldShopLogin
      // if (login) {
      //   login = login.replace(/\./gi, '%2E').replace(/-/gi, '%2D').replace(/_/gi, '%5F')
      // }
      // // const baseUrl = window.location.host.startsWith('staging-office.switips.com') || window.location.host.startsWith('office.switips.com') || window.location.host.startsWith('office.swi.tips') ? 'https://join.swi.tips/?u=' : 'https://myswitplanet.com/?u='
      // const baseUrl = `https://mysplife.onelink.me/HMVb?pid=media_source_app_referrer&c=app_referrer&af_dp=mysplife%3A%2F%2F&is_retargeting=true&deep_link_value=u_${login}&u=${login}`
      // // return baseUrl + login
      // return baseUrl
      return this.shortenedUrl
    },

    downloadLayoutText () {
      if (this.reqCountry.USA) return this.$t('views.Dashboard.PromoMaterials.usaDownloadLayoutText')
      return this.$t('views.Dashboard.PromoMaterials.downloadLayoutText')
    },

    downloadLayoutButtons () {
      const UKRAINE = [
        // {
        //   href: this.staticBaseUrl + '/legal/merchant/promotional_material/promotional_materials_black_uk.zip',
        //   color: 'black',
        //   label: this.$t('buttons.btns_color.black')
        // },
        // {
        //   href: this.staticBaseUrl + '/legal/merchant/promotional_material/promotional_materials_blue_uk.zip',
        //   color: 'blue',
        //   label: this.$t('buttons.btns_color.blue')
        // },
        // {
        //   href: this.staticBaseUrl + '/legal/merchant/promotional_material/promotional_materials_colored_uk.zip',
        //   color: 'secondary',
        //   label: this.$t('buttons.btns_color.colored')
        // },
        {
          href: this.staticBaseUrl + '/legal/merchant/promotional_material/promotional_materials_uk.zip',
          color: 'success',
          label: this.$t('views.Dashboard.PromoMaterials.download')
        }
      ]

      const RUSSIA = [
        // {
        //   href: this.staticBaseUrl + '/legal/merchant/promotional_material/promotional_materials_black.zip',
        //   color: 'black',
        //   label: this.$t('buttons.btns_color.black')
        // },
        // {
        //   href: this.staticBaseUrl + '/legal/merchant/promotional_material/promotional_materials_blue.zip',
        //   color: 'blue',
        //   label: this.$t('buttons.btns_color.blue')
        // },
        // {
        //   href: this.staticBaseUrl + '/legal/merchant/promotional_material/promotional_materials_colored.zip',
        //   color: 'success',
        //   label: this.$t('buttons.btns_color.colored')
        // },
        {
          href: this.staticBaseUrl + '/legal/merchant/promotional_material/promotional_materials.zip',
          color: 'success',
          label: this.$t('views.Dashboard.PromoMaterials.download')
        }
      ]

      const KAZAKHSTAN = [
        // {
        //   href: this.staticBaseUrl + '/legal/merchant/promotional_material/promotional_materials_colored_kz.zip',
        //   color: 'success',
        //   label: this.$t('buttons.btns_color.colored')
        // },
        {
          href: this.staticBaseUrl + '/legal/merchant/promotional_material/promotional_materials_kz.zip',
          color: 'success',
          label: this.$t('views.Dashboard.PromoMaterials.download')
        }
      ]

      const USA = [
        {
          href: this.staticBaseUrl + '/legal/merchant/promotional_material/promotional_materials_us.zip',
          color: 'success',
          label: this.$t('views.Dashboard.PromoMaterials.download')
        }
      ]

      const MEXICO = [
        {
          href: this.staticBaseUrl + '/legal/merchant/promotional_material/promotional_materials_mx.zip',
          color: 'success',
          label: this.$t('views.Dashboard.PromoMaterials.download')
        }
      ]

      if (this.reqCountry.USA) {
        return [
          { buttons: USA }
        ]
      }

      if (this.reqCountry.MEXICO) {
        return [
          { label: 'MX', buttons: MEXICO }
        ]
      }

      if (this.reqCountry.UKRAINE) {
        return [
          // { label: 'RU', buttons: RUSSIA },
          { label: 'UK', buttons: UKRAINE }
        ]
      }

      if (this.reqCountry.KAZAKHSTAN) {
        return [
          { label: 'RU', buttons: RUSSIA },
          { label: 'KZ', buttons: KAZAKHSTAN }
        ]
      }

      if (this.reqCountry.RUSSIA) {
        return [
          { label: 'RU', buttons: RUSSIA }
        ]
      }

      return [
        { buttons: USA }
      ]
    },

    layoutImages () {
      return (this.reqCountry.USA || this.reqCountry.MEXICO) ? [promotionUS1, promotionUS2, promotionUS3] : [promotion1, promotion2, promotion3, promotion4]
    },

    banners () {
      const baseURL300 = this.staticBaseUrl + '/img/merchant/301-549_'
      const baseURL728 = this.staticBaseUrl + '/img/merchant/725-87_'

      if (this.reqCountry.USA || this.$i18n.locale === 'en') {
        return {
          300: [baseURL300 + '1-us.png', baseURL300 + '2-us.png', baseURL300 + '3-us.png', baseURL300 + '4-us.png'],
          728: [baseURL728 + '1-us.png', baseURL728 + '2-us.png', baseURL728 + '3-us.png', baseURL728 + '4-us.png']
        }
      }

      if (this.reqCountry.KAZAKHSTAN || this.$i18n.locale === 'kk') {
        return {
          300: [baseURL300 + '1-kz' + '.png', baseURL300 + '2-kz' + '.png', baseURL300 + '3-kz' + '.png', baseURL300 + '4-kz' + '.png'],
          728: [baseURL728 + '1-kz' + '.png', baseURL728 + '2-kz' + '.png', baseURL728 + '3-kz' + '.png', baseURL728 + '4-kz' + '.png']
        }
      }

      if (this.reqCountry.UKRAINE || this.$i18n.locale === 'uk') {
        return {
          300: [baseURL300 + '1-uk' + '.png', baseURL300 + '2-uk' + '.png', baseURL300 + '3-uk' + '.png', baseURL300 + '4-uk' + '.png'],
          728: [baseURL728 + '1-uk' + '.png', baseURL728 + '2-uk' + '.png', baseURL728 + '3-uk' + '.png', baseURL728 + '4-uk' + '.png']
        }
      }

      if (this.reqCountry.MEXICO || this.$i18n.locale === 'es') {
        return {
          300: [baseURL300 + '1-mx' + '.png', baseURL300 + '2-mx' + '.png', baseURL300 + '3-mx' + '.png', baseURL300 + '4-mx' + '.png'],
          728: [baseURL728 + '1-mx' + '.png', baseURL728 + '2-mx' + '.png', baseURL728 + '3-mx' + '.png', baseURL728 + '4-mx' + '.png']
        }
      }

      return {
        300: [baseURL300 + '1' + '.png', baseURL300 + '2' + '.png', baseURL300 + '3' + '.png', baseURL300 + '4' + '.png'],
        728: [baseURL728 + '1' + '.png', baseURL728 + '2' + '.png', baseURL728 + '3' + '.png', baseURL728 + '4' + '.png']
      }
    }
  },

  methods: {
    copyB (link) {
      try {
        this.copyToClipboard(`<a href="${this.referralLink}" target="_blank"><img alt="banner" src="${link}"></a>`)
        this.$notify({
          position: 'bottom',
          message: this.$t('views.Dashboard.Documentation.notify.copied')
        })
      } catch (e) {
        this.$notify({
          message: this.$t('views.Dashboard.Documentation.notify.notcopied'),
          type: 'error',
          position: 'bottom'
        })
      }
    },

    copyRefLink () {
      try {
        // this.copyToClipboard(this.referralLink)
        this.copyToClipboard(this.referralLink)
        this.$notify({
          message: this.$t('views.Dashboard.Documentation.notify.copied'),
          position: 'bottom'
        })
      } catch (e) {
        this.$notify({
          message: this.$t('views.Dashboard.Documentation.notify.notcopied'),
          type: 'error',
          position: 'bottom'
        })
      }
    },

    generateQr () {
      if (!this.isGoldStatus || !this.goldShopLogin) {
        this.loading = false
        return false
      }
      this.loading = true
      const typeNumber = 0 // Type number (1 ~ 40), or 0 for auto detection
      const errorCorrectionLevel = 'Q' // Error correction level ('L', 'M', 'Q', 'H')
      const cellsize = 10
      const margin = 10
      const qrcode = qr(typeNumber, errorCorrectionLevel)
      qrcode.addData(this.referralLink)
      qrcode.make()
      return qrcode.createDataURL(cellsize, margin)
    },

    download_qr () {
      if (!this.isGoldStatus || !this.goldShopLogin) return false
      const a = document.createElement('a')
      a.href = this.generateQr()
      this.loading = false
      a.download = 'merchant-goldshop-referal-qr.gif'
      a.click()
    }
  },

  async mounted () {
    let login = this.goldShopLogin
    if (login) {
      login = login.replace(/\./gi, '%2E').replace(/-/gi, '%2D').replace(/_/gi, '%5F')
    }
    // this.shortenedUrl = await minify(baseUrl, { provider: 'isgd' }).then(res => res.shortUrl)
    this.shortenedUrl = `https://mysplife.onelink.me/HMVb?pid=media_source_app_referrer&c=app_referrer&af_dp=mysplife%3A%2F%2F&is_retargeting=true&deep_link_value=u_${login}&u=${login}`
  },

  watch: {
    async goldShopLogin (val) {
      let login = val
      if (login) {
        login = login.replace(/\./gi, '%2E').replace(/-/gi, '%2D').replace(/_/gi, '%5F')
      }
      this.shortenedUrl = `https://mysplife.onelink.me/HMVb?pid=media_source_app_referrer&c=app_referrer&af_dp=mysplife%3A%2F%2F&is_retargeting=true&deep_link_value=u_${login}&u=${login}`
    }
  }
}
</script>

<style lang="scss">
.promo-materials {

  &__images-grid{
    display: grid;
    grid-gap: 1.5rem;
    grid-template-rows: auto 1fr;
    grid-template-columns: 1fr 1fr;

    & > img {
      width: 100%;
    }
  }

  &__section {
    display: flex;
    flex-direction: column;

    &:not(:last-of-type) {
      padding-bottom: 5rem;
      /*border-bottom: 1px $color-space-lighten solid;*/
    }

    &:not(:first-of-type) {
      padding-top: 5rem;
    }

    @include respond(tab-port) {
      align-items: center;
      flex-direction: row;
    }

    @include respond(tab-port) {
      margin-left: -2rem;
      margin-right: -2rem;
    }

    &-left, &-right {
      @include respond(tab-port) {
        padding-left: 2rem;
        padding-right: 2rem;
      }
    }

    &-left {
      flex-basis: 100%;
      @include respond(tab-port) {
        flex-basis: 50%;
      }
    }

    &-right {
      flex-basis: 100%;
      margin-bottom: 2rem;
      @include respond(tab-port) {
        flex-basis: 50%;
        margin-bottom: unset;
      }
    }

    &--single {
      display: block;
      text-align: center;
      @include respond(tab-port) {
        padding-left: 2rem;
        padding-right: 2rem;
      }
    }

    &--reverse {
      flex-direction: column-reverse;
      @include respond(tab-port) {
        align-items: center;
        flex-direction: row;
      }
    }
  }

  &__banner{
    border-radius: 4px;
    border: 1px solid $color-grey-lighten;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    &-horizontal{
      width: 100%;
      @include respond(tab-land){
        width: 50%;
      }
    }
    &-vertical{
      width: 100%;
      @include respond(phone-x-large){
        width: 25%;
      }
    }
    &-inner {
      padding: 12px 7px;
      display: flex;
      justify-content: center;
      & img {
        width: 100%;
      }
    }
    &-footer {
      padding: 12px 7px;
      border-top: 1px solid $color-grey-lighten;
      display: flex;
      justify-content: center;
    }
    &-list{
      margin: 0 -1rem;
    }
  }

  &__section-heading {
    font-size: 2.6rem;
    @include respond(tab-port) {
      font-size: 3.6rem;
    }
  }
}
</style>
